// extracted by mini-css-extract-plugin
export default {"note":"SmallNote_note__x85ui","noteTop":"SmallNote_noteTop__mszdB","hoverBtn":"SmallNote_hoverBtn__ue4zA"};